import $ from 'jquery';
import { isSafari } from '../_shared/helpers';

/**
 * @desc Scroll active navigation item into view
 */
export default class SubHeaderNavSlider {
  /**
   * @param {string} sliderSelector
   * @param {string} activeItemSelector
   */
  constructor(sliderSelector, activeItemSelector) {
    this.$slider = $(sliderSelector);
    this.$activeItem = this.$slider.find(activeItemSelector);

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (
      !this.$slider.length
      || !this.$activeItem.length
      || !(this.$slider[0].scrollWidth > this.$slider.width())
    ) {
      this.isInitialized = false;

      return;
    }
    if (isSafari) {
      this.$activeItem[0].scrollIntoViewIfNeeded();
    } else {
      this.$activeItem[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }
}
